import script from "./WIndicatorsStatistic.vue?vue&type=script&setup=true&lang=ts"
export * from "./WIndicatorsStatistic.vue?vue&type=script&setup=true&lang=ts"

import "./WIndicatorsStatistic.vue?vue&type=style&index=0&id=55ae484c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55ae484c"]])

export default __exports__